const s = {
  name: "Expressionless",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8,19h8v-2H8V19z"/>
		<path class="st0" d="M32,19h-8v-2h8V19z"/>
		<path class="st0" d="M16,26v2h8v-2H16z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0z M2,20c0-9.9,8.1-18,18-18
			c9.9,0,18,8.1,18,18c0,9.9-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Expressionless
};
